export default "__VITE_ASSET__CxTaGLXZ__"